import { render, staticRenderFns } from "./OccurrenceTeamRequests.vue?vue&type=template&id=01bc6d2e&scoped=true&"
import script from "./OccurrenceTeamRequests.vue?vue&type=script&lang=js&"
export * from "./OccurrenceTeamRequests.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceTeamRequests.vue?vue&type=style&index=0&id=01bc6d2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bc6d2e",
  null
  
)

export default component.exports